import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from './components/UI/Toast';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import { Home } from './pages/Home';
import { Platform } from './pages/Platform';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { ApiDocs } from './pages/ApiDocs';
import { Dashboard } from './pages/Dashboard';
import { Profile } from './pages/Profile';
import { Orders } from './pages/Orders';
import { Disclosures } from './pages/Disclosures';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
// Admin functionality is now integrated into Dashboard

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <ToastContainer />
          <Routes>
            {/* Public routes - No authentication required */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/docs" element={<ApiDocs />} />
            <Route path="/disclosures" element={<Disclosures />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            {/* Superadmin routes - Dashboard (includes admin functionality) */}
            <Route element={<ProtectedRoute requireSuperadmin />}>
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>

            {/* Redirect legacy /admin route to /dashboard */}
            <Route path="/admin" element={<Navigate to="/dashboard" replace />} />

            {/* Protected routes - Require Read permission */}
            <Route element={<ProtectedRoute requiredPermission="read" />}>
              <Route path="/profile" element={<Profile />} />
              <Route path="/orders" element={<Orders />} />
            </Route>

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
